import { useRoutes } from "react-router-dom";
// components
import Calculator from "../../modules/calculator/components/Calculator";
import SavingsPage from "../../modules/savings/components/SavingsPage";

export default function Router() {
  return useRoutes([
    {
      path: "/",
      element: <Calculator />,
    },
    {
      path: "/savings",
      element: <SavingsPage />,
    },
  ]);
}
